var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 59.2C0 31.293 0 17.34 8.67 8.67 17.34 0 31.293 0 59.2 0h29.6c27.907 0 41.861 0 50.53 8.67C148 17.34 148 31.293 148 59.2v29.6c0 27.907 0 41.861-8.67 50.53C130.661 148 116.707 148 88.8 148H59.2c-27.907 0-41.86 0-50.53-8.67C0 130.661 0 116.707 0 88.8V59.2z",
    fill: "#07F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.19 107.023c-34.496 0-54.172-23.409-54.992-62.362h17.28c.568 28.59 13.306 40.701 23.397 43.198V44.661h16.27V69.32c9.965-1.061 20.432-12.298 23.964-24.658h16.271c-2.712 15.232-14.063 26.468-22.136 31.088 8.073 3.745 21.001 13.546 25.92 31.274h-17.91c-3.847-11.86-13.432-21.037-26.108-22.285v22.285H78.19z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 59.2C0 31.293 0 17.34 8.67 8.67 17.34 0 31.293 0 59.2 0h29.6c27.907 0 41.861 0 50.53 8.67C148 17.34 148 31.293 148 59.2v29.6c0 27.907 0 41.861-8.67 50.53C130.661 148 116.707 148 88.8 148H59.2c-27.907 0-41.86 0-50.53-8.67C0 130.661 0 116.707 0 88.8V59.2z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-2.341 -.91)",
    d: "M0 0h152.682v149.819H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.f02e5ddb87d8e97034e7fb924b4df45a.svg";
export { ForwardRef as ReactComponent };